<div class="col-12" *ngIf="isVisible">
  <breadcrumb></breadcrumb>
  <iframe
    width="100%"
    height="900"
    [src]="report | safeUrl"
    frameBorder="0"
    allowfullscreen="false"
  >
  </iframe>
</div>
